/* eslint-disable react/no-unescaped-entities */

import icon4 from '../../assets/images/all-img/v2/icon4.png';
import icon5 from '../../assets/images/all-img/v2/icon5.png';
import icon6 from '../../assets/images/all-img/v2/icon6.png';
import icon7 from '../../assets/images/all-img/v2/icon7.png';
import icon8 from '../../assets/images/all-img/v2/icon8.png';
import icon9 from '../../assets/images/all-img/v2/icon9.png';

export default function FeatureSectionTwo() {
	return (
		<div className="section bg-gray-800 fugu-section-padding3">
			<div className="container">
				<div className="fugu-section-title title-white">
					<h2>Everything you need for crypto trading is available</h2>
				</div>
				<div className="row">
					<div className="col-lg-4 col-md-6">
						<div className="fugu-iconbox-wrap3 wow fadeInUpX" data-wow-delay="0s">
							<div className="fugu-iconbox-icon3">
								<img src={icon4} alt="" />
							</div>
							<div className="fugu-iconbox-data3">
								<h4>Free trial account</h4>
								<p>
									a product or service that is offered to customers for free for a short period of
									time so they can try using it easily.
								</p>
							</div>
						</div>
					</div>
					<div className="col-lg-4 col-md-6">
						<div className="fugu-iconbox-wrap3 wow fadeInUpX" data-wow-delay="0.10s">
							<div className="fugu-iconbox-icon3">
								<img src={icon5} alt="" />
							</div>
							<div className="fugu-iconbox-data3">
								<h4>Guided by experts</h4>
								<p>
									CryptoExperts SAS is a company founded by internationally recognized industrial &
									academic researchers.
								</p>
							</div>
						</div>
					</div>
					<div className="col-lg-4 col-md-6">
						<div className="fugu-iconbox-wrap3 wow fadeInUpX" data-wow-delay="0.20s">
							<div className="fugu-iconbox-icon3">
								<img src={icon6} alt="" />
							</div>
							<div className="fugu-iconbox-data3">
								<h4>Affordable plans</h4>
								<p>
									If you're ready to invest in some crypto, check out the nexto cheap options that
									could generate nice returns in 2022.
								</p>
							</div>
						</div>
					</div>
					<div className="col-lg-4 col-md-6">
						<div className="fugu-iconbox-wrap3 wow fadeInUpX" data-wow-delay="0.30s">
							<div className="fugu-iconbox-icon3">
								<img src={icon7} alt="" />
							</div>
							<div className="fugu-iconbox-data3">
								<h4>24/7 Live support</h4>
								<p>
									When you need help, our team of experts will work with you via our 24/7 live chat to
									reach a quick & efficient.
								</p>
							</div>
						</div>
					</div>
					<div className="col-lg-4 col-md-6">
						<div className="fugu-iconbox-wrap3 wow fadeInUpX" data-wow-delay="0.40s">
							<div className="fugu-iconbox-icon3">
								<img src={icon8} alt="" />
							</div>
							<div className="fugu-iconbox-data3">
								<h4>Online wallets</h4>
								<p>
									Best for security because it comes with the strongest security features & track
									record of any cryptoo online wallet.
								</p>
							</div>
						</div>
					</div>
					<div className="col-lg-4 col-md-6">
						<div className="fugu-iconbox-wrap3 wow fadeInUpX" data-wow-delay="0.50s">
							<div className="fugu-iconbox-icon3">
								<img src={icon9} alt="" />
							</div>
							<div className="fugu-iconbox-data3">
								<h4>Multi curency support</h4>
								<p>
									Multi-currency support means that shoppers can pay for your products or services
									using the currency.
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
